module.exports = __webpack_public_path__ + "img/item6.a0b2674f.png";